// extracted by mini-css-extract-plugin
module.exports = {"reserve-space-for-highlight":"_2vOM9OX5qrVxwuYw0NGC","danger":"_3614KlJhkKUax7fYTyB4"};